import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import { API_URL, STASH_URL, SIGN_URL, CLIENTS_URL, CURRENCY_URL } from "@/config/api.config";


const ApiService = {
	init() {
		Vue.use(VueAxios, axios);
		Vue.axios.defaults.baseURL = API_URL;
		Vue.axios.defaults.headers = {
			Accept: "*/*"
		};
	},

	setHeader() {
		Vue.axios.defaults.headers.common[
			"Authorization"
		] = `Token ${JwtService.getToken()}`;
	},

	query(resource, params) {
		return Vue.axios.get(resource, params).catch(error => {
			throw new Error(`[RWV] ApiService ${error}`);
		});
	},

	get(resource, slug = "") {
		return Vue.axios.get(`${resource}/${slug}`, {
			headers: {
				'Accept': "*/*",
				'Content-Type': "application/x-www-form-urlencoded"
			}
		}).catch(error => {
			throw new Error(`[RWV] ApiService ${error}`);
		});
	},

	post(resource, params, custom_config) {
		const config = Object.assign({}, custom_config, {
			headers: {
				'Accept': "*/*",
				'Content-Type': "application/x-www-form-urlencoded"
			}
		});
		return Vue.axios.post(`${resource}`, params, config);
	},

	update(resource, slug, params) {
		return Vue.axios.put(`${resource}/${slug}`, params);
	},

	put(resource, params) {
		return Vue.axios.put(`${resource}`, params);
	},

	delete(resource) {
		return Vue.axios.delete(resource).catch(error => {
			throw new Error(`[RWV] ApiService ${error}`);
		});
	}
};

export default ApiService;

export const CheckoutService = {
	// Get Data
	getPaymentMethods(params) {
		return ApiService.query("getPaymentMethods", {
			params: params
		});
	},
	getPaymentRate(params) {
		return ApiService.query("localize", {
			params: params
		});
	},
	getFingerprint(params) {
		return ApiService.query("fingerprint", {
			params: params
		});
	},
	getCurrencies(params) {
		return ApiService.query("currency/details", {
			params: params,
			baseURL: CURRENCY_URL
		});
	},
	stash(params) {
		// We want to post our data to the stash API instead. See documentation:
		// https://docs.withreach.com/display/PUB/Stash
		return ApiService.post(params.MerchantId+"/"+params.StashId, params.data, {
			baseURL: STASH_URL,
			transformRequest: jsonData => transformRequest(jsonData)
		});
	},
	checkout(params) {
		// Post happens differently. We are forcing into a form-submit,
		// So we aren't passing the parameters as "params" to axios
		return ApiService.post("checkout", params, {
			transformRequest: jsonData => transformRequest(jsonData)
		});
	},
	query(params) {
		// Post happens differently. We are forcing into a form-submit,
		// So we aren't passing the parameters as "params" to axios
		return ApiService.post("query", params, {
			transformRequest: jsonData => transformRequest(jsonData)
		});
	}
};

export const MerchantService = {
	load_merchant_info(params) {
		return ApiService.query(params.Client+".json", {
			baseURL: CLIENTS_URL
		});
	},
	load_merchant_rates(params) {
		return ApiService.query("getRates", {
			params: params
		});
	},
	load_badge_info(params) {
		return ApiService.query("badge", {
			params: params
		});
	}
};

/* This is a catch-all service for non-checkout or merchant API calls */
export const GeneralService = {
	verify_checkout(params) {
		return ApiService.post("package/sign", params, {
			baseURL: SIGN_URL
		});
	}
};
